<template lang='pug' src='./home.pug'></template>

<script>
import Loader from 'components/loader/loader'
import Icon from 'components/icon/icon'
import Hero from 'components/hero/hero'
import HeroHome from 'components/hero/hero-home/hero-home'
import VueTrigger from 'components/block/block-vue-trigger/block-vue-trigger'
import TextBox from 'components/block/block-text-box/block-text-box'
import ImgBox from 'components/block/block-img-box/block-img-box'
import SimpleButton from 'components/block/block-simple-button/block-simple-button'
import FunctionButton from 'components/block/block-function-button/block-function-button'
import RouterButton from 'components/block/block-router-button/block-router-button'
import HeaderSection from 'components/block/block-header-section/block-header-section'
import ParallaxSection from 'components/block/block-parallax-section/block-parallax-section'
import TileSection from 'components/custom/custom-tile-repeater/custom-tile-repeater'
import HomeTagline from 'components/custom/custom-home-tagline/custom-home-tagline'
import PercentSection from 'components/custom/custom-percent-section/custom-percent-section'
import TabHeader from 'components/block/block-tab-header/block-tab-header'
import FlexibleFinancingSection from 'components/custom/custom-home-financing/custom-home-financing'

export default {
  name: 'home',
  computed: {
    props () {
      return this.$store.state.pages.home
    },
    loading () {
      return this.$store.state.loading
    }
  },
  methods: {
    navScrolled () {
      this.$store.dispatch('VIEW_NAV', true)
    },
    notScrolled () {
      this.$store.dispatch('VIEW_NAV', false)
    },
    openModal () {
      this.$store.dispatch('VIEW_SHOWMODAL', true)
    }
  },
  components: {
    Loader,
    Hero,
    HeroHome,
    VueTrigger,
    Icon,
    TextBox,
    ImgBox,
    SimpleButton,
    FunctionButton,
    RouterButton,
    HeaderSection,
    ParallaxSection,
    TileSection,
    HomeTagline,
    PercentSection,
    TabHeader,
    FlexibleFinancingSection
  },
  created () {
    // console.log('props = ', this.props)
  }
}
</script>



// WEBPACK FOOTER //
// home.vue?13aa8a72